import {
    SAVE_ORG_FILTER_SETTINGS_START,
    SAVE_ORG_FILTER_SETTINGS_SUCCESS,
    SAVE_ORG_FILTER_SETTINGS_FAIL

} from "../../../constants";
import {
    UPDATE_ORGANIZATION_DATA,
} from "../../../../../config/constants";
import { ApiBase } from "../../../../utils/apiBase";
import { withType } from "../../../../utils/actionOperations";
import { getProjectIdAndOrgId } from '../../../../utils/apiUtils';

export const updateOrganizationDataConfigurations = (payload, cb) => {
    const apiBaseInstance = new ApiBase().instance;
    return (dispatch) => {
        dispatch(
            withType(SAVE_ORG_FILTER_SETTINGS_START, { ...payload })
        );
        return apiBaseInstance
            .post(UPDATE_ORGANIZATION_DATA, {
                ...payload, ...getProjectIdAndOrgId(payload)
            })
            .then((res) => {
                dispatch(
                    withType(SAVE_ORG_FILTER_SETTINGS_SUCCESS, {
                        data: res.data,
                        payload: payload
                    })
                );
                cb && cb(true)
            })
            .catch((err) => {
                dispatch(withType(SAVE_ORG_FILTER_SETTINGS_FAIL, { ...err, ...payload }));
                cb && cb(false)
            });
    };
};

